<template>
  <div class="page-headline">
    <div class="page-headline__contents">
      <Stepper
        :steps="steps"
        :step="step"
        class="page-headline__contents--stepper"
      />
      <div :style="PageHeadlineStyle">
        <h2 v-if="subTitle" class="page-headline__contents--sub-title">
          {{ subTitle }}
        </h2>
        <PageHeadlineTitle :title="title" />
      </div>
    </div>
  </div>
</template>
<script>
import Stepper from '../../atoms/stepper/Stepper.vue'
import PageHeadlineTitle from '../../atoms/headlines/PageHeadlineTitle.vue'
export default {
  components: {
    Stepper,
    PageHeadlineTitle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false,
      default: ''
    },
    steps: {
      type: Array,
      required: true
    },
    step: {
      type: Number,
      required: true
    },
    textAlign: {
      type: String,
      required: false,
      default: 'left'
    }
  },
  computed: {
    PageHeadlineStyle() {
      return {
        'text-align': this.textAlign
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.page-headline {
  background-color: $white;
  padding: 24px 16px;

  &__contents {
    margin: auto;

    &--sub-title {
      font-size: 1rem;
      font-weight: normal;
      line-height: 1.6;
      color: $black;
    }

    &--stepper {
      margin-bottom: 12px;
    }
  }
}
</style>
